import { API, axios, SendRequest} from '@/imports-files/pages/clients/activities/index';


export class MyAccountService extends SendRequest {
  async getDetails(params) {
    try {
      const result = await axios.get(API.client.activities.GET_USER_DETAILS,
        {
          params:params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateUserDetails(params,client_slug)
  {
    try {
      const result = await axios.put(API.client.activities.UPDATE_USER_DETAILS.replace("$client_slug", client_slug),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
